<template>
  <div id="student_info">
    <a-spin :spinning="spinning" size="large">
      <h3>学生列表</h3>
      <div class="info_box">
        <div v-if="gradeClassAll" class="one_part info_flex">
          <a-select style="width: 120px" @change="gradeChange" placeholder="筛选年级" allowClear>
            <a-select-option v-for="(item, index) in editGradeListOne" :key="index + 'a'" :value="item.id">{{item.val}}</a-select-option>
          </a-select>
          <a-select style="width: 120px" @change="classChange" placeholder="筛选班级" allowClear>
            <a-select-option v-for="(item, index) in classChangeList" :key="index + 'b'" :value="item">{{item}}</a-select-option>
          </a-select>
          <a-input v-model="importantInfo" placeholder="姓名/身份证/学籍号" />
          <a-button type="primary" @click="searchHandle">查询</a-button>
          <a-button class="empty_btn" @click="exportStuHandle" style="margin-left: 20px;">导出学生名单</a-button>
        </div>
        <div class="two_part info_flex" style="padding: 16px 24px 16px;">
          <a-button type="primary" @click="batchImportHandle">批量导入</a-button>
          <a-button class="empty_btn" @click="updateTotalPassword">重置所有密码</a-button>
          <a-button type="danger" ghost @click="emptyHandle">清空学生列表</a-button>
        </div>
        <div class="two_part info_flex" style="padding: 0px 24px 24px;">
          <a-button class="empty_btn" @click="onlyImportHandle">单个添加</a-button>
          <!-- v-show="reviseFlag" -->
          <a-button class="empty_btn" @click="updatePassword">重置已选学生密码</a-button>
          <a-button type="danger" ghost @click="removeHandle">删除已选学生</a-button>
        </div>
        <div v-if="schoolInfos">
          <a-table :columns="columns" :dataSource="stuInfoList" :rowKey="row => row.UID" :pagination="{ pageSize, showQuickJumper: true, total: stuTotal, current: stuCurrentNum }" :rowSelection="rowSelection" @change="handTableChange">
            <template slot="SEX" slot-scope="text">{{text === 1 ? '男' : (text === 2 ? '女' : '未知') }}</template>
            <template slot="ENTRYYEAR" slot-scope="text">{{gradeName(text)}}</template>
            <template slot="CLASS_ID" slot-scope="text">{{`${text}班`}}</template>
            <template slot="STUDENT_ID_CARD" slot-scope="text">
              <a-popover>
                <template slot="content">
                  <span>{{`身份证号： ${text ? text : '暂无'}`}}</span>
                </template>
                <a-icon type="eye" theme="filled" />
              </a-popover>
            </template>
            <template slot="STUDENT_ID_SOCIAL" slot-scope="text">
              <a-popover>
                <template slot="content">
                  <span>{{`学籍号： ${text ? text : '暂无'}`}}</span>
                </template>
                <a-icon type="eye" theme="filled" />
              </a-popover>
            </template>
            <template slot="operation" slot-scope="text, record">
              <span class="action" @click="operationHandle(record.UID, record)">编辑</span>
              <span class="action" @click="seeHandle(record.UID)">查看心理档案</span>
              <!-- <a-modal title="编辑学生信息" v-if="record.UID === editUid" v-model="visible" @ok="hideModal" okText="确认" cancelText="取消">
                <template slot="footer">
                  <a-button @click="hideHandel">取消</a-button>
                  <a-button type="primary" @click="hideModal" :disabled="isdisable">确认</a-button>
                </template>
                <div class="edit_box info_flex">
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学校：</span>
                  <span>{{teacherAdmin.school_name}}</span>
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学生姓名：</span>
                  <a-input v-model="editName" placeholder="请输入" style="width: 250px" />
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">性别：</span>
                  <a-select v-model="editSex" style="width: 250px" @change="editSexChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editSexList" :key="index + 'c'" :value="item.id">{{item.val}}</a-select-option>
                  </a-select>
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学籍号：</span>
                  <a-input v-model="editSocial" placeholder="请输入" style="width: 250px" />
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">身份证号：</span>
                  <a-input v-model="editCard" placeholder="请输入" style="width: 250px" />
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right; color: #262626">年级：</span>
                  <a-select v-model="editGrade" style="width: 250px" @change="editGradeChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editGradeList" :key="index + 'e'" :value="item.id">{{item.val}}</a-select-option>
                  </a-select>
                </div>
                <div>
                  <span style="display: inline-block; width: 120px; text-align: right">班级：</span>
                  <a-select v-model="editClass" style="width: 250px" @change="editClassChange" placeholder="请选择">
                    <a-select-option v-for="(item, index) in editChangeClassList" :key="index + 'd'" :value="item">{{item}}</a-select-option>
                  </a-select>
                </div>
              </a-modal> -->
              <a-drawer wrapClassName="drawerEdit" v-if="record.UID === editUid" :width="600" :visible="visibleEdit" :body-style="{ paddingBottom: '80px', paddingTop: '32px' }" :destroyOnClose="true" :closable="false" @close="onClose">
                <span class="back" @click="onClose" style="margin-left: 40px;padding: 8px;box-sizing: border-box;">
                  <a-icon type="left" />
                  返回
                </span>
                <ul>
                  <li v-for="(info, index) in editInfo" :key="index">
                    <p>
                      <b>{{info.name}}</b>
                      <i>{{info.value}}</i>
                    </p>
                    <a-button v-if="index" @click="editClick(info)">编辑</a-button>
                  </li>
                </ul>
                <a-modal wrapClassName="editModal" v-if="editInfoActive" :title="'修改' + editInfoActive.name" v-model="visible" @cancel="hideHandel">
                  <template slot="footer">
                    <a-button @click="hideHandel">取消</a-button>
                    <a-button type="primary" @click="hideModal" :disabled="!(editName || editSex || editSocial || editCard || editGrade || editClass)">确认</a-button>
                  </template>
                  <div v-if="editInfoActive.name === '学生姓名'">
                    <a-input v-model="editName" placeholder="请输入" />
                  </div>
                  <div v-if="editInfoActive.name === '性别'">
                    <a-select v-model="editSex" placeholder="请选择" @change="editSexChange">
                      <a-select-option v-for="(item, index) in editSexList" :key="index + 'c'" :value="item.id">{{item.val}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if="editInfoActive.name === '学籍号'">
                    <a-input v-model="editSocial" placeholder="请输入" />
                  </div>
                  <div v-if="editInfoActive.name === '身份证号'">
                    <a-input v-model="editCard" placeholder="请输入" />
                  </div>
                  <div v-if="editInfoActive.name === '年级'">
                    <a-select v-model="editGrade" @change="editGradeChange" placeholder="请选择">
                      <a-select-option v-for="(item, index) in editGradeList" :key="index + 'e'" :value="item.id">{{item.val}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if="editInfoActive.name === '班级'">
                    <a-select v-model="editClass" @change="editClassChange" placeholder="请选择">
                      <a-select-option v-for="(item, index) in editChangeClassList" :key="index + 'd'" :value="item">{{item}}</a-select-option>
                    </a-select>
                  </div>
                </a-modal>
              </a-drawer>
            </template>
          </a-table>
        </div>
      </div>
      <only-import :gradeInfo="editGradeList"></only-import>
    </a-spin>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import GRADE from '@/util/grade'
import STUDENTFUN from '@/util/studentFun'
import GradeFormat from '@/util/gradeFormat'
// import GradeFormatTwo from '@/util/gradeFormatTwo'
// import GradeYearTwo from '@/util/gradeYearTwo'
import OnlyImport from './OnlyImportStu'
import URL from '@/store/url'
import XLSX from 'xlsx'

export default {
  name: 'StudentInfo',
  components: {
    OnlyImport
  },
  data () {
    return {
      columns: [
        {
          title: '学生姓名',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME',
          // sorter: (a, b) => a.REAL_NAME.localeCompare(b.REAL_NAME, 'zh'),
          sortDirections: ['ascend']
        },
        {
          title: '性别',
          dataIndex: 'SEX',
          key: 'SEX',
          scopedSlots: { customRender: 'SEX' },
          // sorter: (a, b) => a.SEX - b.SEX
        },
        {
          title: '年级',
          dataIndex: 'ENTRYYEAR',
          key: 'ENTRYYEAR',
          scopedSlots: { customRender: 'ENTRYYEAR' },
          // sorter: (a, b) => a.ENTRYYEAR - b.ENTRYYEAR
        },
        {
          title: '班级',
          dataIndex: 'CLASS_ID',
          key: 'CLASS_ID',
          scopedSlots: { customRender: 'CLASS_ID' },
          // sorter: (a, b) => a.CLASS_ID - b.CLASS_ID
        },
        {
          title: '身份证',
          dataIndex: 'STUDENT_ID_CARD',
          key: 'STUDENT_ID_CARD',
          scopedSlots: { customRender: 'STUDENT_ID_CARD' }
        },
        {
          title: '学籍号',
          dataIndex: 'STUDENT_ID_SOCIAL',
          key: 'STUDENT_ID_SOCIAL',
          scopedSlots: { customRender: 'STUDENT_ID_SOCIAL' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      visible: false,
      editUid: null,
      selectedRowKeys: [],
      pageSize: 10,
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          // let rowList = []
          // selectedRows.map(item => {
          //   rowList.push(item.UID)
          // })
          this.selectedRowKeys = selectedRowKeys
          // if (this.removeInfo && this.removeInfo.length !== 0) {
          //   this.removeInfo.map(item => {
          //     this.selectedRowKeys.map((itemOne, index) => {
          //       if (item.uid === itemOne) {
          //         this.selectedRowKeys.splice(index, 1)
          //       }
          //     })
          //   })
          //   // this.selectedRowKeys = selectedRowKeys
          // }
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        },
        onSelect: (record, selected, selectedRows) => {
          if (this.selectedRowKeys.length === 0) {
            this.reviseFlag = false
          } else {
            this.reviseFlag = true
          }
          console.log(record, selected, selectedRows)
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (this.selectedRowKeys.length === 0) {
            this.reviseFlag = false
          } else {
            this.reviseFlag = true
          }
          console.log(selected, selectedRows, changeRows)
        }
      },
      reviseFlag: false,
      stuInfoList: null,
      stuTotals: null,
      gradeClassAll: null,
      gradeVal: null,
      classVal: null,
      importantInfo: null,
      editName: null,
      editSex: undefined,
      editSocial: null,
      editCard: null,
      editGrade: undefined,
      editClass: undefined,
      editSexList: [{id: 1, val: '男'}, {id: 2, val: '女'}],
      editGradeList: null,
      editGradeListOne: null,
      removeInfo: null,
      spinning: true,
      editValue: null,
      visibleEdit: false,
      editInfoActive: null,
      renderName: null,
      renderSex: null,
      renderSocial: null,
      renderCard: null,
      renderGrade: null,
      renderClass: null
    }
  },
  computed: {
    ...mapState([
      'schoolInfos',
      'teacherAdmin',
      'schoolGrades',
      'emptyStuStatus',
      'editBackInfos', // 编辑学生信息后调取接口返回解果
      'editBackStatus',
      'stuTotal',
      'gradeClass',
      'stuCurrentNum',
      'resetStuPassWord',
      'removeStuState'
    ]),
    editInfo () {
      if (this.editValue) {
        console.log(this.renderName)
        return [
          {
            name: '学校',
            value: this.teacherAdmin.school_name
          },
          {
            name: '学生姓名',
            value: this.renderName ? this.renderName : this.editValue.REAL_NAME
          },
          {
            name: '性别',
            value: this.renderSex ? (this.renderSex === 1 ? '男' : (this.renderSex === 2 ? '女' : '未知')) : (this.editValue.SEX === 1 ? '男' : (this.editValue.SEX === 2 ? '女' : '未知'))
          },
          {
            name: '学籍号',
            value: this.renderSocial ? this.renderSocial : (this.editValue.STUDENT_ID_SOCIAL ? this.editValue.STUDENT_ID_SOCIAL : '暂无')
          },
          {
            name: '身份证号',
            value: this.renderCard ? this.renderCard : (this.editValue.STUDENT_ID_CARD ? this.editValue.STUDENT_ID_CARD : '暂无')
          },
          {
            name: '年级',
            value: this.renderGrade ? GRADE.gradeName(this.renderGrade) : this.gradeName(this.editValue.ENTRYYEAR)
          },
          {
            name: '班级',
            value: this.renderClass ? this.renderClass : this.editValue.CLASS_ID + '班'
          }
        ]
      } else {
        return []
      }
    },
    classChangeList () {
      let list = null
      let classList = []
      if (this.gradeVal) {
        const arr = this.gradeClass.filter(item => item.ENTRYYEAR === this.gradeVal)
        if (arr.length) {
          arr.map(item => {
            classList.push(`${item.CLASS_ID}班`)
          })
          classList.sort((a, b) => parseInt(a) - parseInt(b))
          list = classList
        }
      } else {
        if (this.gradeClass) {
          this.gradeClass.map(item => {
            if (!classList.filter(val => val === `${item.CLASS_ID}班`).length) {
              classList.push(`${item.CLASS_ID}班`)
            }
          })
          classList.sort((a, b) => parseInt(a) - parseInt(b))
          list = classList
        }
      }
      return list
    },
    editChangeClassList () {
      let list = null
      let classList = []
      const arr = this.gradeClass.filter(item => item.ENTRYYEAR === this.editValue.ENTRYYEAR)
      if (arr.length) {
        arr.map(item => {
          classList.push(`${item.CLASS_ID}班`)
        })
        list = classList
      }
      return list
    }
  },
  async mounted () {
    await this.getSchoolInfos({skip: 0})
    this.setStuCurrentNum(1)
    if (this.schoolInfos) {
      // this.stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      // this.stuTotals = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      // this.gradeClassAll = STUDENTFUN.uploadData(this.stuInfoList)
      sessionStorage.setItem('stuCount', this.stuTotal)
      setTimeout(() => {
        this.spinning = false
      }, 1000)
    }
    if (this.schoolGrades) {
      this.editGradeList = STUDENTFUN.editGradeReplace(this.schoolGrades)
      this.editGradeListOne = STUDENTFUN.editGradeReplaceOne(this.schoolGrades)
    }
  },
  watch: {
    schoolInfos () {
      this.stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.stuTotals = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.gradeClassAll = STUDENTFUN.uploadData(this.stuInfoList)
      this.getGradeClass()
    }
  },
  methods: {
    ...mapActions([
      'getUpdateStuPassword',
      'removeStuInfo',
      'emptyStuInfo',
      // 'getAddStuInfo',
      'getSchoolInfos',
      'editStuInfo', // 学生列表页编辑学生信息
      'getGradeClass',
      'resetStuPass',
      'logAdd'
    ]),
    ...mapMutations([
      'setOnlyVisible',
      'setStuCurrentNum'
    ]),
    onClose () { // 关闭抽屉
      this.visibleEdit = false
      this.renderName = null
      this.renderSex = null
      this.renderSocial = null
      this.renderCard = null
      this.renderGrade = null
      this.renderClass = null
    },
    gradeChange (value) {
      console.log(value)
      this.gradeVal = value
    },
    classChange (value) {
      this.classVal = value
    },
    gradeName (item) {
      return GradeFormat(item)
    },
    seeHandle (key) { // 查看心理档案
      const info = JSON.parse(sessionStorage.getItem('userInfo'))
      window.open(`${URL.TO_RECORD}?UID=${key}&teacherId=${this.teacherAdmin.uid}&schoolName=${this.teacherAdmin.school_name}&city=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&schoolId=${info.school_id}&roleId=${info.role_id}&jwt=${this.teacherAdmin.jwt}&schoolType=1`)
    },
    operationHandle (key, value) {
      // this.visible = true
      this.visibleEdit = true
      this.editUid = key
      this.editValue = value
    },
    editSexChange (value) {
      this.editSex = value
    },
    editGradeChange (value) {
      this.editGrade = value
    },
    editClassChange (value) {
      console.log(this.editGrade)
      this.editClass = value
    },
    editClick (info) {
      console.log(info)
      this.editInfoActive = info
      this.visible = true
      this.clearFun()
    },
    async hideModal () {
      if (this.editName || this.editSex || this.editGrade || this.editClass || ((this.editCard && this.editCard !== '暂无' ) || (this.editSocial && this.editSocial !== '暂无'))) {
        // if ((this.editName === this.editValue.REAL_NAME) || (this.editSex === this.editValue.SEX) || (this.editGrade === this.editValue.GRADE_ID) || (this.editClass === this.editValue.CLASS_ID + '班') || (this.editCard === this.editValue.STUDENT_ID_CARD) || (this.editSocial === this.editValue.STUDENT_ID_SOCIAL)) {
        //   this.$message.warning('您没有修改喔~')
        // } else {
          let editResult = STUDENTFUN.editTest(this.editCard ? this.editCard : this.editValue.STUDENT_ID_CARD, this.editSocial, this.editSex ? this.editSex : this.editValue.SEX)
          if (editResult === 'success') {
            let dataList = {
              CLASS_ID: this.editInfoActive.name === '班级' ? this.editClass.substring(0, this.editClass.length - 1) : null,
              GRADE_ID: this.editInfoActive.name === '年级' ? this.editGrade : null,
              REAL_NAME: this.editInfoActive.name === '学生姓名' ? STUDENTFUN.palindrome(this.editName) : null,
              SEX: this.editInfoActive.name === '性别' ? this.editSex : null,
              STUDENT_ID_SOCIAL: this.editInfoActive.name !== '学籍号' || this.editSocial === '暂无' ? null : this.editSocial,
              STUDENT_ID_CARD: this.editInfoActive.name !== '身份证号' || this.editCard === '暂无' ? null : this.editCard
              // TS: moment().format('YYYY-MM-DD HH:mm:ss')
            }
            Object.keys(dataList).forEach(item=>{
              if(!dataList[item])  delete dataList[item]
            })
            await this.editStuInfo({
              uid: this.editUid,
              result: dataList
            })
            if (this.editBackStatus >= 400 && this.editBackStatus <= 600) {
              this.$message.success('编辑学生超时，请联系工作人员或稍后再试')
            } else {
              if (this.editBackInfos) {
                this.visible = false
                this.$message.success('编辑学生信息成功')
                await this.getSchoolInfos({skip: (this.stuCurrentNum - 1) * 10, limit: this.pageSize})
                this.renderName = this.editName
                this.renderSex = this.editSex
                this.renderSocial = this.editSocial
                this.renderCard = this.editCard
                this.renderGrade = this.editGrade
                this.renderClass = this.editClass
                await this.logAdd({
                  name: '学生-学生列表-编辑单个学生信息',
                  remarks: `${this.editValue.REAL_NAME}-${(this.renderCard ? this.renderCard : this.editValue.STUDENT_ID_CARD) ? (this.renderCard ? this.renderCard : this.editValue.STUDENT_ID_CARD) : (this.renderSocial ? this.renderSocial : this.editValue.STUDENT_ID_SOCIAL)}`
                })
              } else {
                if (this.editInfoActive.name === '学籍号') {
                  this.$message.warning('学籍号已被占用，请重新设置')
                } else if (this.editInfoActive.name === '身份证号') {
                  this.$message.warning('身份证已被占用，请核实正确后删除学生并重新添加')
                }
              }
            }
          } else {
            if (editResult === 2) {
              this.$message.warning('身份证与性别不符，请核实正确身份证或修改性别')
            }
            if (editResult === 3) {
              this.$message.warning('学籍号超过20位了，请修改')
            }
            if (editResult === 5) {
              this.$message.warning('身份证无效，请核实正确身份证')
            }
          }
        // }
      } else {
        if (!this.editName || !this.editSex || !this.editGrade || !this.editClass) {
          this.$message.warning('请将信息填写完整')
        } else {
          if ((this.editCard === '暂无' || !this.editCard) && (this.editSocial === '暂无' || !this.editSocial)) {
            this.$message.warning('学籍号与身份证至少填写一项')
          }
        }
      }
    },
    hideHandel () {
      this.visible = false
      this.clearFun()
    },
    clearFun () {
      if (this.editInfoActive.name === '性别') {
        this.editSex = undefined
      }
      switch (this.editInfoActive.name) {
        case '学生姓名':
          return this.editName = null
        case '性别':
          return this.editSex = undefined
        case '学籍号':
          return this.editSocial = null
        case '身份证号':
          return this.editCard = null
        case '年级':
          return this.editGrade = undefined
        case '班级':
          return this.editClass = undefined
      }
    },
    // onSelectChange(selectedRowKeys) {
    //   console.log('selectedRowKeys changed: ', selectedRowKeys)
    //   this.selectedRowKeys = selectedRowKeys
    // },
    // onSelectChange (record, selected, selectedRows) { // 单个选择
    //   if (selectedRows.length === 0) {
    //     this.reviseFlag = false
    //   } else if (selectedRows.length === this.stuInfoList.length) {
    //     this.reviseFlag = true
    //     this.reviseFlagTwo = true
    //   } else {
    //     this.reviseFlag = true
    //     this.reviseFlagTwo = false
    //   }
    //   let total = []
    //   selectedRows.map(item => {
    //     total.push(item.UID)
    //   })
    //   this.selectedRowKeys = total
    // },
    // onSelectChangeAll () { // 全选
    //   let listUid = []
    //   this.stuInfoList.map(item => {
    //     listUid.push(item.UID)
    //   })
    //   if (this.selectedRowKeys.length === listUid.length) {
    //     this.reviseFlag = false
    //     this.reviseFlagTwo = false
    //     this.selectedRowKeys = []
    //   } else {
    //     this.reviseFlag = true
    //     this.reviseFlagTwo = true
    //     this.selectedRowKeys = [...listUid]
    //   }
    // },
    async updatePassword () { // 重置密码
      let resetList = []
      this.selectedRowKeys.map(item => {
        resetList.push({uid: item})
      })
      if(resetList.length === 0) {
        this.$message.error('没有选择学生')
        return
      }
      try {
        let res = await this.getUpdateStuPassword({
          data: resetList
        })
        if (res) {
          this.$message.success('重置密码成功')
        } else {
          this.$message.error('重置密码失败')
        }
      } catch (e) {
        console.log(e)
        this.$message.error('重置密码失败')
      }
    },
    async updateTotalPassword () { // 重置所有密码
      this.$confirm({
        title: '重置学生密码，不可撤回操作',
        content: '你还要继续吗',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            await this.resetStuPass()
            if (this.resetStuPassWord) {
              this.$message.success('重置密码成功')
            } else {
              this.$message.error('重置密码失败')
            }
          } catch (e) {
            console.log(e)
            this.$message.error('重置密码失败')
          }
        },
        onCancel() {},
      })
    },
    emptyHandle () {
      this.$confirm({
        title: '清空学生信息后不可恢复',
        content: '你还要继续吗',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          await this.emptyStuInfo()
          if (this.emptyStuStatus) {
            this.$message.success('清空学生信息成功')
            await this.logAdd({
              name: '学生-学生列表-清空学生列表',
              remarks: ''
            })
            this.stuInfoList = []
            this.reviseFlag = false
            await this.getSchoolInfos({skip: 0})
            sessionStorage.setItem('stuCount', this.stuTotal)
          } else {
            this.$message.error('清空学生信息失败')
          }
        },
        onCancel() {},
      })
    },
    removeHandle () {
      let removeList = []
      this.selectedRowKeys.map(item => {
        removeList.push(item)
      })
      if(removeList.length === 0) {
        this.$message.error('没有选择学生')
        return
      }
      this.$confirm({
        title: '删除学生信息后不可恢复',
        content: '你还要继续吗',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          try {
            await this.removeStuInfo({
              data: removeList
            })
            if (this.removeStuState) {
              this.$message.success('删除学生信息成功')
              // this.selectedRowKeys.map(item => {
              //   this.stuInfoList.map((itemOne, index) => {
              //     if (itemOne.UID === item) {
              //       this.stuInfoList.splice(index, 1)
              //     }
              //   })
              // })
              this.selectedRowKeys = []
              await this.logAdd({
                name: '学生-学生列表-删除已选学生',
                remarks: `删除${removeList.length}名学生`
              })
              this.removeInfo = removeList
              this.reviseFlag = false
              this.setStuCurrentNum(1)
              await this.getSchoolInfos({skip: 0})
              sessionStorage.setItem('stuCount', this.stuTotal)
            }
          } catch (e) {
            console.log(e)
            this.$message.error('删除学生信息失败')
          }
        },
        onCancel() {},
      })

    },
    async searchHandle () { // 查询
      if (this.classVal && !this.gradeVal) {
        this.$message.error('必须先选择年级才能搜索班级！')
      } else {
        let obj = {}
        if (this.gradeVal) {
          obj['ENTRYYEAR'] = this.gradeVal
          obj['hide'] = true
        } else {
          obj['hide'] = false
        }
        this.classVal ? obj['CLASS_ID'] = this.classVal.slice(0, this.classVal.length - 1) : true
        console.log(obj)
        this.importantInfo ? obj['SEARCH'] = this.importantInfo : true
        obj['skip'] = 0
        await this.getSchoolInfos(obj)
        this.setStuCurrentNum(1)
        this.stuInfoList = this.stuTotals.filter((item) => !this.gradeVal ? true : item.ENTRYYEAR === parseInt(this.gradeVal)).filter((item) => !this.classVal ? true : item.CLASS_ID === this.classVal.slice(0, this.classVal.length - 1)).filter((item) => !this.importantInfo ? true : item.REAL_NAME.indexOf(this.importantInfo) !== -1 || (item.STUDENT_ID_CARD ? item.STUDENT_ID_CARD.indexOf(this.importantInfo) !== -1 : '') || (item.STUDENT_ID_SOCIAL ? item.STUDENT_ID_SOCIAL.indexOf(this.importantInfo) !== -1 : ''))
      }
    },
    batchImportHandle () { // 批量导入
      this.$router.push('/studentList/totalImport')
    },
    onlyImportHandle () { // 单个导入
      this.setOnlyVisible(true)
    },
    async exportStuHandle () { // 导出学生名单
      let finishData = []
      let yearList = []
      let totalArr = []
      await this.getSchoolInfos({total: true})
      this.stuInfoList.map(item => {
        if (!yearList.includes(item.ENTRYYEAR)) {
          yearList.push(item.ENTRYYEAR)
        }
      })
      yearList.sort((a, b) => b - a)
      yearList.map(item => {
        let classList = []
        let everyList = this.stuInfoList.filter(val => val.ENTRYYEAR === item)
        everyList.map(val => {
          if (!classList.includes(val.CLASS_ID)) {
            classList.push(val.CLASS_ID)
          }
        })
        classList.sort((a, b) => a - b)
        classList.map(itemOne => {
          let classArr = everyList.filter(key => key.CLASS_ID === itemOne).sort((a, b) => a.REAL_NAME.localeCompare(b.REAL_NAME, 'zh-CN'))
          totalArr = [...totalArr, ...classArr]
        })
      })
      totalArr.map(item => {
        finishData.push({'姓名': item.REAL_NAME, '性别': item.SEX === 1 ? '男' : (item.SEX === 2 ? '女' : '未知'), '年级': this.gradeName(item.ENTRYYEAR), '班级': `${item.CLASS_ID}班`, '学籍号': item.STUDENT_ID_SOCIAL, '身份证号': item.STUDENT_ID_CARD})
      })
      let wb = {
        SheetNames: [],
        Sheets: { sheet1: 'ww' }
      }
      let ws = XLSX.utils.json_to_sheet(finishData)
      XLSX.utils.book_append_sheet(wb, ws, '学生名单')
      XLSX.writeFile(wb, `${this.teacherAdmin.school_name}学生名单.xlsx`, { compression: true })
      await this.logAdd({
        name: '学生-学生列表-导出学生名单',
        remarks: ''
      })
    },
    async handTableChange (info) {
      this.setStuCurrentNum(info.current)
      this.pageSize = info.pageSize
      if (!this.gradeVal && !this.classVal && !this.importantInfo) {
        await this.getSchoolInfos({skip: (info.current - 1) * 10, limit: this.pageSize})
      } else {
        let obj = {}
        if (this.gradeVal) {
          obj['ENTRYYEAR'] = this.gradeVal
          obj['hide'] = true
        } else {
          obj['hide'] = false
        }
        this.classVal ? obj['CLASS_ID'] = parseInt(this.classVal) : true
        this.importantInfo ? obj['SEARCH'] = this.importantInfo : true
        obj['skip'] = (info.current - 1) * 10
        obj['limit'] = this.pageSize
        await this.getSchoolInfos(obj)
      }
    }
  }
}
</script>

<style>
#student_info {
  width: 100%;
  padding: 32px 0px 50px 24px;
  box-sizing: border-box;
}
#student_info .info_flex {
  display: flex;
  align-items: center;
}
#student_info h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 24px;
}
#student_info .info_box {
  width: 100%;
  padding: 24px 0px 0px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
}
#student_info .info_box .one_part {
  width: 100%;
  padding: 0px 24px;
  box-sizing: border-box;
}
#student_info .info_box .one_part .ant-select, #student_info .info_box .two_part .ant-btn {
  margin-right: 16px;
}
#student_info .info_box .one_part .ant-input {
  width: 180px;
  margin-right: 16px;
}
#student_info .info_box .two_part {
  width: 100%;
  padding: 16px 24px 24px;
  box-sizing: border-box;
}
#student_info .ant-table-pagination.ant-pagination {
  margin: 24px 24px 24px;
}
#student_info .ant-btn-primary, .ant-modal-footer .ant-btn-primary, .ant-modal-confirm .ant-btn-primary {
  color: #FFFFFF;
  background-color: #51BF94;
  border-color: #51BF94;
}
#student_info .ant-btn-primary:hover, #student_info .ant-btn-primary:focus, .ant-modal-footer .ant-btn-primary:hover, .ant-modal-confirm .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
#student_info .empty_btn:hover, #student_info .empty_btn:focus {
  color: #51BF94;
  border-color: #51BF94;
}
.ant-modal-footer {
  text-align: center;
}
#student_info .action {
  cursor: pointer;
  color: #1890FF;
}
#student_info .action:first-child {
  padding-right: 25px;
}
#student_info .ant-table-thead > tr > th:nth-child(6), #student_info .ant-table-thead > tr > th:nth-child(7), #student_info .ant-table-tbody > tr > td:nth-child(6), #student_info .ant-table-tbody > tr > td:nth-child(7) {
  text-align: center;
}
.drawerEdit ul {
  padding: 0px 40px;
  box-sizing: border-box;
}
.drawerEdit ul li {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid #E8E8E8;
  padding: 24px 0px;
}
.drawerEdit ul li:first-child {
  border-top: 0px;
}
.drawerEdit ul li p {
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
}
.drawerEdit ul li p b {
  font-size: 16px;
  color: #262626;
}
.drawerEdit ul li p i {
  font-style: normal;
  font-size: 14px;
  color: 262626;
  margin-top: 16px;
}
.drawerEdit ul li:first-child p i {
  color: rgba(23, 26, 29, 0.24);
}
.drawerEdit .ant-drawer-mask {
  background-color: transparent!important;
}
.editModal .ant-modal .ant-modal-content {
  padding: 22px 16px;
  box-sizing: border-box;
  z-index: 99999;
}
.editModal .ant-modal-header {
  border-bottom: 0px;
  padding-left: 16px;
}
.editModal .ant-modal-header div {
  font-size: 18px;
  font-weight: bold;
  color: #171A1D;
}
.editModal .ant-modal-body {
  padding: 8px 16px 22px 16px;
}
.editModal .ant-modal-body input, .editModal .ant-modal-body .ant-select, .editModal .ant-modal-body .ant-select .ant-select-selection--single, .editModal .ant-modal-body .ant-select .ant-select-selection--single .ant-select-selection__rendered {
  width: 100%!important;
  height: 46px!important;
  line-height: 46px!important;
}
.editModal .ant-modal-footer {
  text-align: right;
  border-top: 0px;
}
.editModal .ant-modal-close-x {
  line-height: 96px;
}
.editModal .ant-modal-close-x .anticon {
  padding: 4px;
  box-sizing: border-box;
}
.editModal .ant-modal-close-x .anticon:hover, .drawerEdit .ant-drawer-body > span:hover {
  background: #F5F5F5;;
  /* box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1); */
  cursor: pointer;
}
</style>
